import * as React from 'react';
import { SVGProps } from 'react';

const SearchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={19} height={18} xmlns="http://www.w3.org/2000/svg" {...props}>
    <g transform="translate(-1.991 -2.5)" stroke="#000" strokeWidth={1.5} fill="none" fillRule="evenodd">
      <circle transform="rotate(-45 9.833 9.833)" cx={9.833} cy={9.833} r={6.203} />
      <path d="m14.367 14.395 5.624 5.614" />
    </g>
  </svg>
);

export default SearchIcon;